/**
 * Os editores de um ref conferem (o `validate` de cada um: o de fórmula, o de regras, o do padrão…) — o ref
 * como o Vue o dá, sozinho ou em lista (num `v-for`, os dois lados da associação). Todos, e não até o
 * primeiro que falha: cada um acusa o seu. Ausente — fora da tela, ou ainda carregando —, não barra: o
 * servidor confere de novo ao salvar.
 *
 * Era o "toca o editor e confere a última checagem" escrito em cada formulário que tem fórmula.
 */
export function editorsValid(ref: unknown): boolean {
    return ([ref].flat() as Array<{ validate(): boolean } | undefined>)
        .map(editor => !editor || editor.validate())
        .every(Boolean)
}
